<template lang="pug">
nav(v-if="breadcrumbs.length", aria-label="breadcrumb")
  ol.breadcrumb
    li.breadcrumb-item.active(
      v-for="(crumb, key) in breadcrumbs",
      :key="'breadcrumb_' + key",
      aria-current="page"
    )
      a(v-if="crumb.update", @click="$emit('Update')", href="#") {{ crumb.name }}
      router-link(v-else, :to="{ path: crumb.link }") {{ crumb.name }}
</template>

<script>
export default {
  props: ["breadcrumbs", "route", "warehouse"],
  mounted() {
    console.log("breadcrumbs", this.breadcrumbs);
  },
};
</script>